export class ApiRequestError extends Error {
    readonly displayMessage: string;
    readonly toastShown: boolean;
    readonly originalError: unknown;

    constructor(displayMessage: string, originalError: unknown, toastShown = false) {
        super(displayMessage);
        this.name = "ApiRequestError";
        this.displayMessage = displayMessage;
        this.toastShown = toastShown;
        this.originalError = originalError;
    }
}

export const isApiRequestError = (error: unknown): error is ApiRequestError =>
    error instanceof ApiRequestError;

export const shouldShowErrorToast = (error: unknown): boolean =>
    !isApiRequestError(error) || !error.toastShown;
